import { makeStyles } from "@mui/styles";
import styled from "styled-components";

export const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiPaper-root": {
      marginBottom: "16px",
    },
  },
  wrapper: {
    background: "white",
    position: "sticky",
    top: "0px",
    zIndex: 10,
    height: "150px",
    padding: "20px",
    marginBottom: "16px",
  },
  preview: {
    display: "flex",
    justifyContent: "space-between",
    padding: "10px",
  },
  closeIcon: {
    cursor: "pointer",
  },
  container: {
    marginTop: "10px",
    marginBottom: "16px",
  },
  pdfWrapper: {
    marginTop: "50px",
    position: "relative",
    zIndex: -9999,
    marginBottom: "16px",
  },
  imageWrapper: {
    display: "flex",
    gap: "40px",
    marginBottom: "16px",
  },
  form: {
    display: "flex",
    gap: "16px",
    marginBottom: "16px",
  },
  paper: {
    padding: "16px",
    marginBottom: "16px",
  },
  textField: {
    width: "250px",
  },
  createButton: {
    width: "150px",
  },
  selectButton: {
    width: "200px",
  },
  menuItem: {
    background: "#F7F5FF",
    padding: "8px 16px",
  },
  menuSubItem: {
    padding: "8px 16px",
    textTransform: "uppercase",
  },
  // Table specific styles
  tableContainer: {
    overflowX: "auto",
    maxWidth: "100%",
    position: "relative",
  },
  table: {
    minWidth: 1200,
    tableLayout: "fixed",
  },
  stickyFirstColumn: {
    position: "sticky",
    left: 0,
    minWidth: 80,
    width: 80,
    maxWidth: 80,
  },
  stickyLastColumn: {
    position: "sticky",
    right: 0,
    backgroundColor: "rgb(255, 255, 255)",
    minWidth: 160,
    width: 160,
    maxWidth: 160,
    borderLeft: "1px solid rgb(255, 255, 255)",
  },
  stickyFirstColumnBody: {
    position: "sticky",
    left: 0,
    zIndex: 1,
    backgroundColor: "rgb(255, 255, 255)",
    borderRight: "1px solid #e0e0e0",
  },
  stickyLastColumnBody: {
    position: "sticky",
    right: 0,
    zIndex: 1,
    backgroundColor: "rgb(255, 255, 255)",
    borderLeft: "1px solid #e0e0e0",
  },
  // Column width definitions
  examPaperIdColumn: {
    minWidth: 150,
    width: 150,
    maxWidth: 150,
  },
  collegeIdColumn: {
    minWidth: 100,
    width: 100,
    maxWidth: 100,
  },
  collegeNameColumn: {
    minWidth: 150,
    width: 150,
    maxWidth: 150,
  },
  academicYearIdColumn: {
    minWidth: 120,
    width: 120,
    maxWidth: 120,
  },
  academicYearNameColumn: {
    minWidth: 140,
    width: 140,
    maxWidth: 140,
  },
  batchIdColumn: {
    minWidth: 100,
    width: 100,
    maxWidth: 100,
  },
  batchNameColumn: {
    minWidth: 120,
    width: 120,
    maxWidth: 120,
  },
  classIdColumn: {
    minWidth: 100,
    width: 100,
    maxWidth: 100,
  },
  classNameColumn: {
    minWidth: 120,
    width: 120,
    maxWidth: 120,
  },
  boardIdColumn: {
    minWidth: 100,
    width: 100,
    maxWidth: 100,
  },
  boardNameColumn: {
    minWidth: 120,
    width: 120,
    maxWidth: 120,
  },
  isArchivedColumn: {
    minWidth: 100,
    width: 100,
    maxWidth: 100,
  },
  createdByColumn: {
    minWidth: 120,
    width: 120,
    maxWidth: 120,
  },
  updatedByColumn: {
    minWidth: 120,
    width: 120,
    maxWidth: 120,
  },
  createdAtColumn: {
    minWidth: 140,
    width: 140,
    maxWidth: 140,
  },
  tableCell: {
    padding: "8px 12px",
    fontSize: "0.875rem",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  tableHeaderCell: {
    padding: "12px",
    fontSize: "0.875rem",
    fontWeight: 600,
    backgroundColor: "#f5f5f5",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  paginationWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    paddingTop: "8px",
  },
  actionRow: {
    textAlign: "center",
  },  
  action: {
    display: "flex",
    justifyContent: "space-evenly",
  },
}));
